import type { RuleHandler } from "../types";
import { outcomesInclude } from "../outcomesInclude";

const checkAllOutcomeGroupsMustMatch: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return outcomesInclude(
    new Set(requirementAttributes?.outcomeGroups),
    context.selection.outcomeGroups,
    requirementAttributes?.allOutcomeGroupsMustMatch || false,
  );
};

export { checkAllOutcomeGroupsMustMatch };
